import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";
export const updateENACH = (details, cb) => {
    return dispatch => {
        dispatch({ type: actionType.LOADER_TRUE });
        axios.post(`${apiConstants().PROPOSEL_API_URL}api/v1/ops/eNACH/save-emandate-receipt`,details, {
           
                
            headers: {
                "Content-Type": "application/json",
                authorization: localStorage.getItem("token"),
                },
            
        }).then((res) => {
            dispatch({ type: actionType.LOADER_FALSE })
            if (res && res.data.body) {
                dispatch({
                    type: actionType.ENACH_UPDATE,
                    // data: res.data.body
                })
                if(cb){
                    cb(res)
                }
                toaster("success", res.data.message)
                
            } else {
                toaster("error", res.data.message)
            }
        }).catch(() => {
            dispatch({ type: actionType.LOADER_FALSE })
        })
    }
}
